// 小微政通
import Log from '../view/log'
import PoliticalCommunicationNav from '../view/PoliticalCommunication/PoliticalCommunicationNav'
import QuarterlyDataReportManage from '../view/PoliticalCommunication/QuarterlyDataReport/QuarterlyDataReportManage'
import QuarterlyDataReportModify from '../view/PoliticalCommunication/QuarterlyDataReport/QuarterlyDataReportModify'
import AnnualDataReportManage from '../view/PoliticalCommunication/AnnualDataReport/AnnualDataReportManage'
import AnnualDataReportModify from '../view/PoliticalCommunication/AnnualDataReport/AnnualDataReportModify'

export default [
  /* 小微政通 */
  {
    path: '/quarterly_data_report_manage',
    name: 'quarterly-data-report-manage',
    components: {
      default: PoliticalCommunicationNav,
      a: QuarterlyDataReportManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/quarterly_data_report_modify/:id',
    name: 'quarterly-data-report-modify',
    components: {
      default: PoliticalCommunicationNav,
      a: QuarterlyDataReportModify
    }
  },
  {
    path: '/annual_data_report_manage',
    name: 'annual-data-report-manage',
    components: {
      default: PoliticalCommunicationNav,
      a: AnnualDataReportManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/annual_data_report_modify/:id',
    name: 'annual-data-report-modify',
    components: {
      default: PoliticalCommunicationNav,
      a: AnnualDataReportModify
    }
  },
  /* 小微政通 */
  // 小微政通操作日志
  {
    path: '/political_communication_log',
    name: 'political-communication-log',
    components: {
      default: PoliticalCommunicationNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/PoliticalCommunication.js